import { Modal as ModalSuite } from 'rsuite';
import './styles.css';
import { useCustomTheme } from '../../../hooks/useCustomTheme';

function RModal({
  open,
  onClose,
  title,
  size,
  footer,
  children,
  bodyWidth = 'auto',
  bodyStyle = {},
}) {
  const { theme } = useCustomTheme();

  return (
    <ModalSuite
      backdrop={'static'}
      className="custom-modal"
      open={open}
      onClose={onClose}
      size={size}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
      }}
    >
      <ModalSuite.Header>
        <ModalSuite.Title style={{ color: theme.colors.text }}>
          {title}
        </ModalSuite.Title>
      </ModalSuite.Header>
      <ModalSuite.Body style={{ width: bodyWidth, ...bodyStyle }}>
        {children}
      </ModalSuite.Body>
      <ModalSuite.Footer>
        <ModalSuite.Footer
          style={{ display: 'flex', justifyContent: 'flex-end' }}
        >
          {footer}
        </ModalSuite.Footer>
      </ModalSuite.Footer>
    </ModalSuite>
  );
}

export default RModal;
